import React from 'react'
import { format } from 'date-fns'
import CalendarIcon from '../../../../Svg/CalendarIcon'

const DisplayDate = ({dateStart, dateEnd, removeIcon, onClick}) => {
    if (format(dateStart, 'yyyy') === format(dateEnd, 'yyyy')){
      if (format(dateStart, 'MMM') === format(dateEnd, 'MMM')) {
        if (format(dateStart, 'd') === format(dateEnd, 'd')) {
          return (
            <div className='datepicker_toggler' onClick={onClick}>
              <span>{format(dateStart, 'd')}&nbsp;</span>
              <span className='text_mutted'>{format(dateStart, 'MMM')}, {format(dateStart, 'yyyy')}</span>
              {removeIcon ? '':<CalendarIcon />}
            </div>)
          
        } else {
          return (
            <div className='datepicker_toggler' onClick={onClick}>
              <span>{format(dateStart, 'd')}-{format(dateEnd, 'd')}&nbsp;</span>
              <span className="text_mutted">{format(dateStart, 'MMM')}, {format(dateStart, 'yyyy')}</span>
              {removeIcon ? '': <CalendarIcon />}
            </div>)
        }
      } else {
        return (
          <div className='datepicker_toggler' onClick={onClick}>
            <span>{format(dateStart, 'd')}&nbsp;</span>
            <span className="text_mutted">{format(dateStart, 'MMM')}-</span>
            <span>{format(dateEnd, 'd')}&nbsp;</span>
            <span className="text_mutted">{format(dateEnd, 'MMM')}, {format(dateStart, 'yyyy')}</span>
            {removeIcon ? '': <CalendarIcon />}
          </div>)
        
      }
    } else {
      return (
        <div className='datepicker_toggler' onClick={onClick}>
          <span>{format(dateStart, 'd')}&nbsp;</span>
          <span className="text_mutted">{format(dateStart, 'MMM')}, {format(dateStart, 'yyyy')}-</span>
          <span>{format(dateEnd, 'd')}&nbsp;</span>
          <span className="text_mutted">{format(dateEnd, 'MMM')}, {format(dateEnd, 'yyyy')}</span>
          {removeIcon ? '': <CalendarIcon />}
        </div>)
    }
  }


export default DisplayDate